import * as types from '../const/action.types';

export function dashboard(state = [], action) {
    switch (action.type) {
        case types.DASHBOARDS_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return [];
        default:
            return state;
    }
}

export function indicators(state = [], action) {
    switch (action.type) {
        case types.LOAD_INDICATORS_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return [];
        default:
            return state;
    }
}

export function charts(state = [], action) {
    switch (action.type) {
        case types.DASHBOARDS_CURRENT_TAB:
            return action.data;
        case types.LOG_OUT:
            return [];
        default:
            return state;
    }
}

export function dashboardHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.DASHBOARD_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function indicatorsHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.INDICATORS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function dashboardIsLoading(state = false, action) {
    switch (action.type) {
        case types.DASHBOARDS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/dashboard.reducer.js